import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, mergeProps as _mergeProps, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createBlock as _createBlock } from "vue"

import { ref } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'MainMenu',
  setup(__props) {

const menuItems = ref([
  { title: 'Home', route: { name: 'home' }, icon: 'fa-home' },
  { title: 'Appointments', route: { name: 'appointments' }, icon: 'fa-calendar' },
  { title: 'Shop', route: { name: 'shop' }, icon: 'fa-shopping-bag' },
  { title: 'Orders', route: { name: 'orders' }, icon: 'fa-shopping-cart' },
  { title: 'Documents', route: { name: 'document-documents' }, icon: 'fa-file' },
  { title: 'Forms', route: { name: 'document-forms' }, icon: 'fa-list-alt' },
  { title: 'Health Suite', route: { name: 'health-suite' }, icon: 'fa-heart' },
  { title: 'My Profile', route: { name: 'client' }, icon: 'fa-user' },
]);

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_menu = _resolveComponent("v-menu")!

  return (_openBlock(), _createBlock(_component_v_menu, null, {
    activator: _withCtx(({ props }) => [
      _createVNode(_component_v_btn, _mergeProps({ icon: "" }, props), {
        default: _withCtx(() => [
          _createVNode(_component_v_icon, {
            class: "primary-color",
            icon: "fa-bars",
            size: "20"
          })
        ]),
        _: 1
      }, 16)
    ]),
    default: _withCtx(() => [
      _createVNode(_component_v_list, null, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(menuItems.value, (item, index) => {
            return (_openBlock(), _createBlock(_component_v_list_item, {
              key: index,
              to: item.route,
              "prepend-icon": item.icon
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_list_item_title, null, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(item.title), 1)
                  ]),
                  _: 2
                }, 1024)
              ]),
              _: 2
            }, 1032, ["to", "prepend-icon"]))
          }), 128))
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})